import * as React from "react";
import * as ReactGA from "react-ga";
import * as ReactPixel from "react-facebook-pixel";

interface TrackClickProps extends ReactGA.EventArgs {
  render: (h: React.MouseEventHandler<any>) => false | JSX.Element | null;
  onClick?: React.EventHandler<any>;
}

class TrackClick extends React.Component<TrackClickProps> {
  private handleClick = (event: React.MouseEvent<any>) => {
    const { render, onClick, ...gaArgs } = this.props;

    if (process.env.NODE_ENV === "production") {
      ReactGA.event(gaArgs);
      ReactPixel.trackCustom("Click", gaArgs);
    }

    // Manual event propagation
    if (onClick) {
      onClick(event);
    }
  };

  public render() {
    return this.props.render(this.handleClick);
  }
}

export default TrackClick;



// WEBPACK FOOTER //
// ./src/hoc/TrackClick.tsx